import axios from 'axios';
import { authenticatedAxios } from './axiosConfig';
import { ExecutionScoresAggregateResponse, SubmitExecutionScoreRequest, ExecutionScoreResponse } from '../types/executionScore';

export class ExecutionScoreService {
  private static instance: ExecutionScoreService;

  private constructor() {}

  public static getInstance(): ExecutionScoreService {
    if (!ExecutionScoreService.instance) {
      ExecutionScoreService.instance = new ExecutionScoreService();
    }
    return ExecutionScoreService.instance;
  }

  async submitScore(request: SubmitExecutionScoreRequest): Promise<ExecutionScoreResponse> {
    try {
      const response = await authenticatedAxios.post<ExecutionScoreResponse>(
        '/execution-scores',
        request
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw new Error(error.response?.data?.message || 'Failed to submit score');
      }
      throw error;
    }
  }

  async getScoresForExecution(executionId: string): Promise<ExecutionScoresAggregateResponse> {
    try {
      const response = await authenticatedAxios.get<ExecutionScoresAggregateResponse>(
        `/execution-scores/${executionId}`
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw new Error(error.response?.data?.message || 'Failed to get scores');
      }
      throw error;
    }
  }

  async getMyScore(executionId: string): Promise<ExecutionScoreResponse | null> {
    try {
      const response = await authenticatedAxios.get<ExecutionScoreResponse>(
        `/execution-scores/${executionId}/my-score`
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 404) {
        return null;
      }
      if (axios.isAxiosError(error)) {
        throw new Error(error.response?.data?.message || 'Failed to get my score');
      }
      throw error;
    }
  }
}
